<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["loyalty_programs"] }}
        </p>
      </div>
      <p class="content_title" v-if="cards.length > 0">
        {{ this.$store.getters.TRANSLATIONS["list_of_loyalty_programs"] }}
      </p>
      <p class="content_title" v-if="cards && cards.length <= 0">
        {{ this.$store.getters.TRANSLATIONS["no_loyalty_programs"] }}
      </p>
      <div v-for="item in cards" :key="item.id">
        <div class="cards">
          <p class="code">{{ item.code || "" }}</p>
          <p class="cardLabel">{{ item.label || "" }}</p>
          <img :src="cardIcon" class="card" />
        </div>
        <button class="button select" v-on:click="next(item)">SELECT</button>
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="add()" class="button new">
        {{ this.$store.getters.TRANSLATIONS["add_new_card"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%; text-align: center" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created() {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
      return;
    }
    const timeout = setTimeout(() => {
      this.loading = true;
    }, 0);
    this.$http
      .get(`${process.env.SERVER_URL}/A420598EE15811EA87D00242AC130003`, {
        headers: {
          "x-access-token": this.$storage.get("parkendaToken")
        }
      })
      .then((response) => {
        console.log("Get user loyalty vouchers response:");
        console.log(response);
        if (response.data) {
          this.cards = response.data;
        } else {
          console.log("Can't get loyalty vouchers information");
        }
      })
      .then(() => {
        return this.$http
          .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
            headers: {
              "x-access-token": this.$storage.get("parkendaToken")
            }
          })
          .then((response) => {
            console.log("Get current user response:");
            console.log(response);
            if (response.data) {
              this.$store.dispatch("SAVE_USER", response.data);
              this.defaultCardId = response.data.defaultCardId;
            }
          });
      })
      .catch((error) => {
        let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
        this.$modal.show("dialog", {
          text,
          buttons: [
            {
              title: "OK",
              handler: () => {
                this.$storage.remove("parkendaToken");
                this.$router.push("/login");
              }
            }
          ]
        });
      })
      .finally(() => {
        clearTimeout(timeout);
        this.loading = false;
      });
  },
  data() {
    return {
      loading: true,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      cards: [],
      cardIcon: require("@/assets/new_design/card.png"),
      next: (item) => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .get(
            `${process.env.SERVER_URL}/0EACE7B4C5C04C1B95BB3CDFB24960C7/${item.externalId}`,
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Get card by id response:");
            console.log(response);
            let User = this.$store.getters.USER;
            User.selectedLoyaltyProgram = item;
            this.$store.dispatch("SAVE_USER", User);
            this.$router.push("/loyaltyEdit");
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              text = error.response.data.error;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$storage.remove("parkendaToken");
                    this.$router.push("/login");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      back: () => {
        this.$router.go(-1);
      },
      add: () => {
        this.$router.push("/loyaltyAdd");
      }
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.cards {
  position: relative;
}
.cards p {
  position: absolute;
  color: #fbae31;
}
.code {
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.cardLabel {
  top: 56%;
  left: 50%;
  transform: translate(-74%, 59%);
  font-size: 11px;
  width: 31%;
  height: 20%;
  overflow: hidden;
}
.select {
  width: 30%;
}
.new {
  background-color: rgba(114, 174, 255, 1);
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/LoyaltyVouchers/List.vue